<template>
  <transition 
    name="base-flyout-fade" 
    appear
  >
    <div
      v-scroll-lock="bodyScrollIsLocked"
      :class="baseFlyoutClasses"
      class="base-flyout"
      @click="closeFlyout"
    >
      <transition 
        name="base-flyout-slide" 
        appear
      >
        <div 
          class="base-flyout__window" 
          @click.stop
        >
          <div class="base-flyout__header">
            <slot 
              :close-flyout="closeFlyout" 
              name="header"
            />
          </div>

          <div class="base-flyout__content">
            <slot 
              :close-flyout="closeFlyout" 
              name="content"
            />
          </div>

          <div 
            v-if="$slots.footer" 
            class="base-flyout__footer"
          >
            <slot 
              :close-flyout="closeFlyout" 
              name="footer"
            />
          </div>

          <transition name="base-flyout-fade">
            <div 
              v-if="isLoading" 
              class="base-flyout__loading"
            >
              <base-spinner />
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: function (value) {
      return ["small", "medium", "large"].includes(value);
    },
  },
  preventClose: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close-flyout"]);

const flyoutWindowIsVisible = ref(false);
const bodyScrollIsLocked = ref(true);

const baseFlyoutClasses = computed(() => ({
  [`base-flyout--size-${props.size}`]: true,
}));

const closeFlyout = () => {
  if (!props.preventClose) {
    emit("close-flyout");
  }
};

onMounted(() => {
  setTimeout(() => {
    flyoutWindowIsVisible.value = true;
  }, 2000);
});
</script>

<style lang="scss" scoped>
@import "./base-flyout.scss";
</style>
